export default __webpack_public_path__ + "ab878710cc461f5172577d3b69d0437b.png";